const PEDIX_DOMAIN_REGEX = /(?:^|\.)(?:pedix\.app|pedixapp\.com|pedixwpp\.com|pedix\.dev|pedix\.local)$|^[\d.]+$/i;

export function isPedixDomain(hostname: string): boolean {
  return PEDIX_DOMAIN_REGEX.test(hostname);
}
